import ApiFetcher from 'lib/api_fetcher'

const removeFavorite = (product, successCallback) => {
  PubSub.publish('loading-page')

  console.log(successCallback)

  return new ApiFetcher({
    key: 'remove_favorite',
    method: 'DELETE',
    endpoint: `/products/${product}/remove_favorite`
  }).call()
    .then(() => {
      successCallback()
      // send({type: 'REFRESH'})
      // addToast('Producto eliminado de favoritos', {appearance: 'info', autoDismiss: true})
    })
    .finally(() => PubSub.publish('loaded-page'))
}

export default removeFavorite
